//import React from 'react';
import axios from 'axios';
import i18n from '../i18n-ok';
import jwt from 'jsonwebtoken'


//--------------------------------------------------------|
// BASE PATH
//--------------------------------------------------------|
// Extract from vanilla window
const envSettings = window;
const api = {
    "host":      (
        // Merge all values into BASE_URL constant
        envSettings.LOOPBACK_PROTOCOL + "://" +
        envSettings.LOOPBACK_HOSTNAME +
        (envSettings.LOOPBACK_PORT   ? ":" + envSettings.LOOPBACK_PORT : "") +
        (envSettings.LOOPBACK_PREFIX ? envSettings.LOOPBACK_PREFIX     : "")
    ),
    "projectId": 314
}
//--------------------------------------------------------|
// ROLE BASED PERMISSION
//--------------------------------------------------------|
const ROLES_CAN_EDIT = [0, 1];           //const ROLES_CAN_EDIT = [0, 1, 2];
//--------------------------------------------------------|

function makeApiUrl(endpoint, filters = null, noproject = false) {          //Dopo aver fatto il transfer alla V2 questa è da comentare
    let accessToken = localStorage.getItem("access_token");
    let projectId = localStorage.getItem("currentProjectId");
    return api.host + endpoint + "?access_token=" + accessToken + (!noproject ? "&projectId=" + projectId : "") + (filters ? filters : "");
}

//Questa function è utilizza un interceptor di axios per inserire un token automaticamente nel header a gli endpoints.
axios.interceptors.request.use(function (config) {
    const accessToken = localStorage.getItem('access_token');

    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    } else {
        config.headers.Authorization = null
    }

    return config;
});

/**
 * Richiesta di Sign-in utente
 */
export const Login = function (username, password) {
    return axios.post(api.host + '/auth/login', { "email": username, "password": password })
        .then(res => {
            return res;
        }).catch(err => {
            return err.response;
        });
}


/**
 * checkLoginStatus
 * Verifica se il token è ancora valido
 */
export const checkLoginStatus = function (updateLoginStatus) {
    let access_token = localStorage.getItem('access_token');
    // Il token di accesso e le informazioni sull'utente sono presenti?
    if (access_token == null) {
        // Dati sul token non presenti -> Escon con stato di utente non loggato
        updateLoginStatus({ "loggedInStatus": "NOT_LOGGED_IN" });
        return;
    }
    else {
        // Dati di accesso presenti. Verifica della loro validità
        //let userId = localStorage.getItem('userId');
        let token = localStorage.getItem('access_token');
        let decodedToken = jwt.decode(token, { complete: true });
        let uuid = decodedToken.payload.id
        getUser(uuid)
            .then((res) => {
                updateLoginStatus({ "loggedInStatus": "LOGGED_IN" });
                if (res.data) {
                    // Aggiorna il localStorage
                    localStorage.setItem("user", JSON.stringify(res.data.rows[0]));
                    i18n.changeLanguage(res.data.rows[0].language);
                }
                return;
            })
            .catch((err) => {
                console.error(err);
                // Resetta i parametri in localStorage relativi a token, uid e projectid
                clearSession();
                updateLoginStatus({ "loggedInStatus": "NOT_LOGGED_IN" });
                return;
            });
    }
}

/*export const userCanEdit = function () {
    try {
        let user = JSON.parse(localStorage.getItem('user'));
        let role = Number(user.userRoleId);

        if (user && ROLES_CAN_EDIT.includes(role)) {
            return true;
        }
    }
    catch (e) {
        // Nothing
    }

    return false;
}*/

export const userCanEdit = function () {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        const roleMappings = {
            "TENANTADMIN": 0,
            "USER": 1,
            "GUEST": 2
        };
        const role = roleMappings[user.role]; 

        if (user && role !== undefined && ROLES_CAN_EDIT.includes(role)) {
            return true;
        }
    } catch (e) {
        // Nothing
    }
    return false;
}

export const clearSession = function () {
    localStorage.removeItem("user");
    localStorage.removeItem("currentProjectId");
    localStorage.removeItem("access_token");
    localStorage.removeItem("userId");
    localStorage.removeItem("projectId");
    localStorage.removeItem("deviceTypeInfo");
}

export const postCabinet = function (payload) {
    return axios.post(api.host + "/cabinet/_create", payload);
}

export const putCabinet = function (uuid, payload) {
    return axios.put(api.host + "/cabinet/" + uuid , payload);
}

export const removeCabinet = function (uuid) {
    return axios.delete(api.host + "/cabinet/" + uuid);
}

export const getUser = function (uuid) {
    return axios.get(api.host +"/user/" + uuid)
}

export const editUser = function (user) {
    return axios.put(api.host + '/user/' + user.uuid, {
        language: user.language
    });
}

//export const getProject = function (projectId) {
//    return axios.get(makeApiUrl("/admin/projects/" + projectId));
//}
export const getProject = function () {
    return axios.post(api.host + "/project/_search")
}

//GET MARKERS

export const getMarkers = function (bbox, projectUuid) {
    const payload = {
        bbox: bbox,
        projectuuid: projectUuid,
    }

    return axios.post(api.host + "/feature/_search", payload)
}

export const getCabinets = function (projectuuid) {
    return axios.post(api.host + "/cabinet/_search", {
        projectuuid: projectuuid
    });
}

export const getCabinetByID = function (uuid) {
    return axios.get(api.host + "/cabinet/" + uuid);
}

export const getLightPoints = function (projectId = {}) {
    return axios.post(api.host +"/lightpoint/_search", {
        projectuuid: projectId
    });
}

export const getLightPointByID = function (uuid) {
    return axios.get(api.host + "/lightpoint/" + uuid);
}

export const postLightPoint = function (payload) {
    return axios.post(api.host + "/lightpoint/_create", payload);
}

export const putLightPoint = function (uuid, payload) {
    return axios.put(api.host + "/lightpoint/" + uuid, payload);
}

export const removeLightPoint = function (uuid) {
    return axios.delete(api.host + "/lightpoint/" + uuid );
}

export const getLightPoint = function (uuid = null, properties = {}) {
    if (uuid === null) {
        return axios.post(api.host +"/lightpoint/_search", { params: properties });
    }
    else {
        return axios.get(api.host + "/lightpoint/" + uuid, { params: properties });
    }
}

/*export const getLightPoint = function (id = null, properties = {}) {
    if (id === null) {
        return axios.get(makeApiUrl("/plant/lightpoints"), { params: properties });
    }
    else {
        return axios.get(makeApiUrl("/plant/lightpoints/" + id), { params: properties });
    }
}*/

/**
 * Sezione di lettura archivi
 */

//export const getLuminares = function () {             DEPRECATA. I dati della tabella luminares sono stati integrti in lamparchive 
//   return axios.get(makeApiUrl("/plant/luminares"));
//}

//export const getDrivers = function () {               DEPRECATA. I dati della tabella luminares sono stati integrti in lamparchive 
//    return axios.get(makeApiUrl("/plant/drivers"));
//}

export const getLamps = function (projectuuid) {
    return axios.post(api.host + "/lamparchive/_search", {
        projectuuid: projectuuid
    });
}

//export const getSupports = function () {              DEPRECATA. I dati della tabella luminares sono stati integrti in lamparchive
//    return axios.get(makeApiUrl("/plant/supports"));
//}

/**
 * Sezione Device
 */

//export const getDevices = function (filters) {            PRIMA CERA QUESTO FILTERS
//    return axios.post( api.host + "/device/_search/", "&filter=" + JSON.stringify(filters) );
//}

export const getDevices = function (sn, isGateway, projectUuid) { 
    return axios.post( api.host + "/device/_search", {
        sn: sn, 
        isgateway: isGateway,
        projectuuid: projectUuid,
    });
}

export const getDevice = function (uuid) {
    return axios.get(api.host + "/device/" + uuid);
}

//export const deviceExists = function (serial) {                   //Non serve a niente questo endpoint
//    return axios.head(makeApiUrl("/archive/devices/" + serial));
//}

export const postDevice = function (properties) {

    const formattedProperties = {
        sn: properties.sn, 
        macaddress: properties.macAddress,
        projectuuid: properties.projectId,
        addresscode: properties.addressCode 
    };

    return axios.post(api.host + "/device/_create", formattedProperties);
}

export const putDevice = function (uuid, properties) {
    return axios.put(api.host + "/device/" + uuid, properties);
}

export const DelDeviceOrThingRelation = function (uuid, thinguuid) {                //Delete a device/thing association
    return axios.delete(api.host + "/device/" + uuid + "/thing/" + thinguuid)
}           

/*export const setDeviceLinkOld = function (serial, lightPointId) {
    return axios.patch(makeApiUrl("/archive/devices/" + serial + "/setLink"), { "lightPointId": lightPointId });
}*/

export const setDeviceLink = function (deviceUuid, thingentity, thingUuid) {
    let body = {}

    if (thingentity === "cabinet") {
        body.thinguuid = thingUuid;
        body.thingentity = "cabinet";
    }
    else {
        body.thinguuid = thingUuid;
        body.thingentity = "lightpoint";
    }

    return axios.post(api.host + "/device/" + deviceUuid + "/thing/_link/", body);
}

export const getDeviceTypeInfo = function () {
    return axios.post(api.host +"/deviceprofile/_search");
}

export const getDeviceProfileByUuid = function (uuid) {
    return axios.get(api.host + "/deviceprofile/" + uuid)
}

/**
 * Sezione Radio Node
*/
export const getRadioNodes = function (properties = {}) {
    return axios.get(makeApiUrl("/plant/radionodes"), { params: properties });
}

/**
 * Sezione riconoscimento dispositivo
 */
export const getDeviceType = function (sn) {
    let deviceTable = JSON.parse(localStorage.getItem('deviceTypeInfo'));
    const devErr = {
        "code": "",
        "name": "Unknown",
        "deviceTypeId": 1
    }

    // Controllo
    let res = deviceTable.find((x) => { return x.fcserialnumber === sn[0] && x.scserialnumber === sn[1] });
    if (res === undefined) {
        return devErr;
    }
    else {
        return res;
    }
}

/**
 * Sezione upload
 */
export const uploadJsonCSV = function (projectId, csvData ) {
    return axios.post(api.host + "/project/" + projectId + "/_bulkimport", csvData, {
        headers: { 'Content-Type': 'application/json' }
    });
}
